import { Sizes } from '../types/sizes'
import { Colors } from '../types/colors'
import * as Spacing from './sizes'
import * as Typography from './typography'
import * as TypographyTypes from '../types/typography'
import { lightColors } from './colors'
import { UseDimensions } from './hooks'

export interface DiscoveryTheme {
  name: string
  colors: Colors
  sizes: Sizes
  fontFamilies: TypographyTypes.FontFamilies
  fontSizes: TypographyTypes.TextSizes
  scale: UseDimensions['scale']
  selectDeviceType: UseDimensions['selectDeviceType']
}

export const darkTheme = (scale: UseDimensions['scale'], selectDeviceType: UseDimensions['selectDeviceType']): DiscoveryTheme => {
  return {
    name: 'dark',
    colors: lightColors,
    sizes: Spacing.sizes(scale, selectDeviceType),
    fontFamilies: Typography.fontFamilies,
    fontSizes: Typography.fontSizes(scale, selectDeviceType),
    scale: scale,
    selectDeviceType: selectDeviceType,
  }
}

export * from './colors'
export * from './sizes'
export * from './typography'
export * from './typography'
export * from '../types/typography'
export * from '../types/colors'
export * from './hooks'
export * from '../types/sizes'
